import * as React from "react";
import "@aurodesignsystem/auro-button";
import "@alaskaairux/auro-icon";
import { useLocation } from "react-router-dom";
import "./TitleBarEventType.scss";

interface TitleBarEventTypeProps {
  eventTitle: string;
  contextPath: string;
  createClicked?: any;
}

export default function TitleBarEventType(props: TitleBarEventTypeProps) {
  const title = "Event Type Management";
  const CreateTitle = "Create event type";
  const location = useLocation();
  const [showCreateButton, setShowCreateButton] = React.useState(true);
  const [labelText, setLabelText] = React.useState(title);

  const setTitlebarText = () => {
    if (location.pathname.indexOf("/edit-event-type") > -1) {
      setLabelText(props.eventTitle);
      setShowCreateButton(false);
    } else if (location.pathname.indexOf("/create-event-type") > -1) {
      setLabelText(CreateTitle);
      setShowCreateButton(false);
    }else {
      setLabelText(title);
      setShowCreateButton(true);
    }
  };

  React.useEffect(() => {
    setTitlebarText();
    return () => {
    }
  }, [location.pathname]);
  return (
    <div className={`titlebar titlebar_create ${props.eventTitle !== undefined ? 'ots-modal-background' : ''}`}>
            <div className={"titlebar-container-event-dashboard titlebar_creates-event-dashboard"} >

      <label className="lbleventtype"> {labelText}</label>
      {showCreateButton && (
        <div className="fullWidth">
          <auro-button
            variant="primary"
            fluid="true"
            onClick={() => props.createClicked(true)}
          >
            <span className="btnlabel-white">Create event type</span>
          </auro-button>
        </div>
      )}
      </div>
      </div>
  );
}
